/**
 * reinforcement.jsx — M3/M9 (Phase 2 Engagement)
 * ==============================================
 * Déclenche le moteur de renforcement VARIABLE côté serveur et affiche, le cas
 * échéant, un feedback premium (toast Dark Luxury, ton coach pro, jamais "jeu vidéo").
 * Fire-and-forget : ne casse jamais le flux appelant.
 */
import React from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Sparkles, TrendingUp, CalendarCheck, Eye, RotateCcw, X } from 'lucide-react';

const FORM_ICON = {
    immediate: Sparkles,
    gauge: TrendingUp,
    deferred: CalendarCheck,
    social: Eye,
    victory: RotateCcw,
    first_contact: Sparkles,
};

function ReinforcementCard({ feedback, onClose }) {
    const Icon = FORM_ICON[feedback.form] || Sparkles;
    const success = feedback.tone === 'success';
    const accent = success ? '#34D399' : '#A855F7';
    return (
        <div
            data-testid="reinforcement-toast"
            style={{
                position: 'relative',
                display: 'flex',
                gap: 12,
                alignItems: 'flex-start',
                width: 340,
                maxWidth: '90vw',
                padding: '14px 16px',
                borderRadius: 16,
                background: 'rgba(18, 12, 28, 0.92)',
                border: '1px solid rgba(255,255,255,0.08)',
                borderLeft: `3px solid ${accent}`,
                backdropFilter: 'blur(16px)',
                boxShadow: `0 12px 40px rgba(0,0,0,0.45), 0 0 24px ${accent}22`,
            }}
        >
            <div
                style={{
                    width: 38,
                    height: 38,
                    flexShrink: 0,
                    borderRadius: 12,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: `${accent}1f`,
                    color: accent,
                }}
            >
                <Icon size={19} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontSize: 13.5, fontWeight: 700, color: '#fff', margin: 0, lineHeight: 1.25 }}>
                    {feedback.title}
                </p>
                <p style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.62)', margin: '3px 0 0', lineHeight: 1.4 }}>
                    {feedback.message}
                </p>
            </div>
            <button
                onClick={onClose}
                aria-label="Fermer"
                style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.35)', cursor: 'pointer', padding: 2, flexShrink: 0 }}
            >
                <X size={15} />
            </button>
        </div>
    );
}

/**
 * triggerReinforcement
 * @param {string} context  action_logged | mandate_updated | visit_logged | alert_resolved
 * @param {string|null} mandateId
 * @param {function=} onChange  callback (ex: rafraîchir la jauge de suivi)
 */
export async function triggerReinforcement(context = 'action_logged', mandateId = null, onChange) {
    try {
        const { data } = await api.post('/engagement/reinforcement', {
            context,
            mandate_id: mandateId || null,
        });
        if (data && data.feedback) {
            toast.custom(
                (t) => <ReinforcementCard feedback={data.feedback} onClose={() => toast.dismiss(t)} />,
                { duration: 4500 }
            );
        }
    } catch (e) {
        // silencieux — l'engagement ne doit jamais casser un flux métier
    } finally {
        if (typeof onChange === 'function') onChange();
    }
}

export default triggerReinforcement;
